// extracted by mini-css-extract-plugin
export var card = "_m8-1";
export var summary = "_m8-0";